var swatches = document.querySelectorAll('.swatch-switch')

swatches.forEach((swatch) => {
  let variant, product;

  swatch.addEventListener('click', (e) => {
    var swatchButtons = swatch.closest('.product-swatch').querySelectorAll('button');
    swatchButtons.forEach((button) => {
      button.classList.remove('active');
    });
    swatch.classList.add('active');
    
    // Get variant and product
    variant = swatch.dataset['button']
    product = swatch.closest('.product-item');
    let productImage = product.querySelectorAll('.product-item__image')[0];
    let variantImage = product.querySelector(".variant-" + variant);
    let previewImages = product.querySelectorAll('.preview-image-for-swatch');
    // Hide all preview images
    previewImages.forEach((previewImage) => {
      previewImage.style.opacity = 0;
      previewImage.style.visibility = 'hidden';
    });

    // Show variant image
    productImage.style.opacity = 0;
    productImage.style.visibility = 'hidden';
    variantImage.style.opacity = 1;
    variantImage.style.visibility = 'visible';

  });
});